import LandingGlpLoader from '@/modules/Landing/components/LandingGlpLoader.vue'
import LandingKovaCalculator from '@/modules/Landing/components/LandingKovaCalculator.vue'
import LandingKovaCta from '@/modules/Landing/components/LandingKovaCta.vue'
import LandingKovaFaq from '@/modules/Landing/components/LandingKovaFaq.vue'
import LandingKovaFooter from '@/modules/Landing/components/LandingKovaFooter.vue'
import LandingKovaHeader from '@/modules/Landing/components/LandingKovaHeader.vue'
import LandingKovaHero from '@/modules/Landing/components/LandingKovaHero.vue'
import LandingKovaHeroPromo from '@/modules/Landing/components/LandingKovaHeroPromo.vue'
import LandingKovaHeroUsa from '@/modules/Landing/components/LandingKovaHeroUsa.vue'
import LandingKovaProduct from '@/modules/Landing/components/LandingKovaProduct.vue'
import LandingKovaResults from '@/modules/Landing/components/LandingKovaResults.vue'
import LandingKovaReviews from '@/modules/Landing/components/LandingKovaReviews.vue'
import LandingKovaSteps from '@/modules/Landing/components/LandingKovaSteps.vue'
import LandingKovaV2Benefits from '@/modules/Landing/components/v2/LandingKovaV2Benefits.vue'
import LandingKovaV2FinalOffer from '@/modules/Landing/components/v2/LandingKovaV2FinalOffer.vue'
import LandingKovaV2Hero from '@/modules/Landing/components/v2/LandingKovaV2Hero.vue'
import LandingKovaV2HowItWorks from '@/modules/Landing/components/v2/LandingKovaV2HowItWorks.vue'
import LandingKovaV2Outcomes from '@/modules/Landing/components/v2/LandingKovaV2Outcomes.vue'
import LandingKovaV2Providers from '@/modules/Landing/components/v2/LandingKovaV2Providers.vue'
import LandingKovaV2Testimonials from '@/modules/Landing/components/v2/LandingKovaV2Testimonials.vue'
import LandingKovaV2Treatment from '@/modules/Landing/components/v2/LandingKovaV2Treatment.vue'
import LandingKovaV2Trust from '@/modules/Landing/components/v2/LandingKovaV2Trust.vue'

export default [
	LandingGlpLoader,
	LandingKovaHeader,
	LandingKovaHero,
	LandingKovaHeroPromo,
	LandingKovaHeroUsa,
	LandingKovaCalculator,
	LandingKovaResults,
	LandingKovaSteps,
	LandingKovaReviews,
	LandingKovaProduct,
	LandingKovaFaq,
	LandingKovaCta,
	LandingKovaFooter,

	// The /app-v2 blocks (DEV-35932). Each declares its name via defineOptions — the registry
	// is indexed by `component.name`.
	LandingKovaV2Hero,
	LandingKovaV2Trust,
	LandingKovaV2HowItWorks,
	LandingKovaV2Treatment,
	LandingKovaV2Testimonials,
	LandingKovaV2Providers,
	LandingKovaV2Benefits,
	LandingKovaV2Outcomes,
	LandingKovaV2FinalOffer,
]
